var carousel = (($) => {

	const slickOptions = {
		autoplay: true,
		autoplaySpeed: 5000,
		infinite: true,
		arrows: false,
	};

	const init = () => {
		$('.hero-carousel').slick(slickOptions);
	};

	return {
		init,
	};
})(jQuery);

export {carousel as default};